import Vue from 'vue'
import Router from 'vue-router'

import store from '@/store'
import RouterUtils from '@/router/RouterUtils'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: RouterUtils.getRoutes()
})

RouterUtils.router = router

router.beforeEach((to, from, next) => {
  let roles = store.getters.getRoles
  if (to.name === 'Login') issetRoles() ? next({name: RouterUtils.getDefaultPageOfRole(roles[0])}) : next()
  else {
    if (!to.meta.roles) next()
    else {
      if (!issetRoles()) redirectToLogin(next)
      else {
        let allow = false
        to.meta.roles.forEach((role, index, array) => {
          if (roles.indexOf(role) !== -1) allow = true
        })
        allow ? next() : redirectToLogin(next)
      }
    }
  }
})

function issetRoles () {
  return !!store.getters.getRoles
}

function redirectToLogin (next) {
  next({name: 'Login'})
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js